if (typeof window.__printovaLockBodyScroll !== 'function') {
  window.__printovaLockBodyScroll = function () {
    document.body.style.overflow = 'hidden';
  };
  window.__printovaUnlockBodyScroll = function () {
    document.body.style.overflow = '';
  };
}
var lockBodyScrollBuild = window.__printovaLockBodyScroll;
var unlockBodyScrollBuild = window.__printovaUnlockBodyScroll;

if (!customElements.get('printova-build-modal')) {
  class PrintovaBuildModal extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.trigger = document.querySelector('[data-printova-build-trigger]');
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.open());
      }

      this.closeBtn = this.querySelector('[data-build-close]');
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      this._onKey = (e) => {
        if (!this.hasAttribute('open')) return;
        if (e.key === 'Escape') this.close();
      };
    }

    open() {
      if (this.parentNode !== document.body) {
        document.body.appendChild(this);
      }
      this.setAttribute('open', '');
      lockBodyScrollBuild();
      document.addEventListener('keydown', this._onKey);
      if (this.closeBtn) {
        setTimeout(() => this.closeBtn.focus(), 50);
      }
    }

    close() {
      this.removeAttribute('open');
      unlockBodyScrollBuild();
      document.removeEventListener('keydown', this._onKey);
      if (this.trigger && typeof this.trigger.focus === 'function') {
        this.trigger.focus();
      }
    }
  }

  customElements.define('printova-build-modal', PrintovaBuildModal);
}
